import { inject, Injectable } from "@angular/core";
import { endpoints } from "../../environments/endpoints";
import { ApiService } from "../Modules/Shared/Services/api.service";
import { CreateUserPayload, IndexQueryParams, RemoveSeatResponse, StoreResponse, UpdateResponse, UpdateUserPayload } from "../Interfaces/api/users.interface";
import { IndexResponse } from "../Interfaces/api/users.interface";
import { HttpParams, HttpResourceRequest } from "@angular/common/http";
import { ShowResponse } from "../Interfaces/api/users.interface";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class UsersService {
    private _apiService = inject(ApiService);

    index(queryParams?: IndexQueryParams, skipLoading: boolean = true): HttpResourceRequest {
        const params = this.buildQueryParams(queryParams);
        return this._apiService.get<IndexResponse>(endpoints.api.users.index, { params, skipLoading, });
    }

    show(userId: string, skipLoading: boolean = true): HttpResourceRequest {
        return this._apiService.get<ShowResponse>(endpoints.api.users.show(userId), { skipLoading });
    }

    create(payload: CreateUserPayload, skipLoading: boolean = false): Observable<StoreResponse> {
        const request = this._apiService.post<StoreResponse>(endpoints.api.users.create, { body: payload, skipLoading });
        return this._apiService.run<StoreResponse>(request);
    }

    update(userId: string, payload: UpdateUserPayload, skipLoading: boolean = false): Observable<UpdateResponse> {
        const request = this._apiService.put<UpdateResponse>(endpoints.api.users.update(userId), { body: payload, skipLoading });
        return this._apiService.run<UpdateResponse>(request);
    }

    removeSeat(userId: string, skipLoading: boolean = false): Observable<RemoveSeatResponse> {
        const request = this._apiService.put<RemoveSeatResponse>(endpoints.api.users.removeSeat(userId), { skipLoading });
        return this._apiService.run<RemoveSeatResponse>(request);
    }

    private buildQueryParams(queryParams?: IndexQueryParams): HttpParams {
        let params = new HttpParams();
        params = params.set('pageSize', queryParams?.pageSize?.toString() ?? '10');
        params = queryParams?.page != null ? params.set('page', queryParams.page.toString()) : params;
        params = queryParams?.orderBy ? params.set('orderBy', queryParams.orderBy) : params;
        params = queryParams?.search ? params.set('search', queryParams.search) : params;
        params = queryParams?.order ? params.set('order', queryParams.order) : params;
        return params;
    }
}